/**
 * Users
 */

// React
import React, { FunctionComponent, useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getReportsCurrentOrdersAction } from './actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectReportCurrentOrderslist,
} from './selectors';

// Components
import ListReportsCurrentOrders from './componets/listReportsCurrentOrders';
import CSVCurrentOrders from './componets/csvCurrentOrders';

// UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Typography, Paper, CircularProgress, Grid } from '@material-ui/core';

// Type
import { Props, SelectorProps } from './interfaces';

// StyleExpansionPanel
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    title: {
      '@media (max-width: 768px)': {
        fontSize: '18px',
        fontWeight: '500',
      },
    },
  })
);

const Reports: FunctionComponent<Props> = (props: Props) => {
  const [filtersValues] = useState({
    page: 0,
    size: 10,
  } as any);

  useEffect(() => {
    getReportsCurrentOrders();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();

  const getReportsCurrentOrders = () => {
    props.reportCurrentOrdersDispatch({});
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" component="h2" className={classes.title}>
            {`سفارش‌های جاری`}
          </Typography>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          direction="row-reverse"
          alignItems="center"
        >
          <CSVCurrentOrders
            data={props.reportCurrentOrdersList}
            filtersValues={filtersValues}
            loading={props.loading}
          />
        </Grid>

        <Grid item xs={12}>
          <div>{`تعداد مراکز فعال:${props.reportCurrentOrdersList?.centers?.length}`}</div>

          <Paper>
            {props.loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              <>
                <ListReportsCurrentOrders
                  data={props.reportCurrentOrdersList}
                  history={props.history}
                />
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  reportCurrentOrdersList: makeSelectReportCurrentOrderslist(),

  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    reportCurrentOrdersDispatch: (payload: Object) =>
      dispatch(getReportsCurrentOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Reports);
